import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FirstSection from "../components/global/firstSection"
import SecondSection from "../components/global/secondSection"
import styled from "styled-components"
import ThirdSection from "../components/global/thirdSection"
import FourthSection from "../components/global/fourthSection"
import FifthSection from "../components/global/fifthSection"
import SixthSection from "../components/global/sixthSection"
import { graphql } from "gatsby"

const Spacer = styled.div`
  padding: ${({ size }) => (size ? size : 2.5)}rem;
`

const IndexPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO title="Just Do It. What’s Your Dream?" />
      <Layout>
        <FirstSection />
        <Spacer />
        <SecondSection />
        <Spacer size={4} />
        <ThirdSection />
        <Spacer size={4} />
        <FourthSection />
        <Spacer size={4} />
        <FifthSection />
        <Spacer size={6} />
        <SixthSection />
        <Spacer size={4} />
      </Layout>
    </React.Fragment>
  )
}

export default IndexPage
